import { render, staticRenderFns } from "./HouseScreen.vue?vue&type=template&id=280ff69a&scoped=true"
import script from "./HouseScreen.vue?vue&type=script&lang=js"
export * from "./HouseScreen.vue?vue&type=script&lang=js"
import style0 from "./HouseScreen.vue?vue&type=style&index=0&id=280ff69a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ff69a",
  null
  
)

export default component.exports